import { React } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
// import ButtonGroup from '../elements/ButtonGroup';
// import Button from '../elements/Button';
import Image from '../elements/Image';
// import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};
//
// const externamImages = [
//   './../../assets/skills1.jpg',
//   './../../assets/skills5x2.jpg',
//   './../../assets/skills6x2.jpg',
//   './../../assets/al1.jpg',
//   './../../assets/094503.jpg',
// ];

//
// const externamImages = [
//   'https://ibb.co/r3j8Xpz',ę
//   'https://ibb.co/rQBQv7j',
//   'https://ibb.co/pZNx9ZD',
//   'https://ibb.co/pdjXK32',
//   'https://ibb.co/4fBTDy0',
// ];
//

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  // const [videoModalActive, setVideomodalactive] = useState(false);

  // const openModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(true);
  // };

  // const closeModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(false);
  // };

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom"
              data-reveal-delay="100"
            >
              Metalo
              <span className="text-color-primary"> studija </span>
            </h1>
            <div className="container-xs">
              <p
                className="m-0 mb-32 reveal-from-bottom"
                data-reveal-delay="400"
              >
                Ilgametė metalurgijos patirtis ir optimalus gamybos procesų
                optimizavimas
              </p>

              <div className="reveal-from-bottom " data-reveal-delay="100">
                {/* <ButtonGroup>
                  <Button
                    tag="a"
                    color="primary"
                    wideMobile
                    href="https://cruip.com/"
                  >
                    Get started
                  </Button>
                  <Button
                    tag="a"
                    color="dark"
                    wideMobile
                    href="https://github.com/cruip/open-react-template/"
                  >
                    View on Github
                  </Button>
                </ButtonGroup> */}
              </div>
            </div>
          </div>
          <div
            className="split-item-image hero-figure reveal-from-bottom illustration-element-01  tiles-item-image"
            data-reveal-value="2px"
            data-reveal-delay="100"
          >
            {/* <a
              // data-video="https://player.vimeo.com/video/174002812"
              // datasrc={externamImages[0]}
              href="#0"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills1.jpg')}
                alt="Hero"
                width={200}
                height={204}
              />
            </a> */}
            <a
              href="#0"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills1.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={230}
              />
            </a>
            {/* <a
              href="#0"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills5x2.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a> */}
            {/* <a
              href="#0"
              data-src="./../../assets/skils101.jpg"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills6x2.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a> */}
            {/* <a
              href="#0"
              data-src="./../../assets/skils101.jpg"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/al1.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a> */}
            <a
              href="#0"
              // data-src="./../../assets/skils101.jpg"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills5x2.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
                aria-controls="modal-is-active"
                // onClick={openModal}
              />
            </a>
            <a
              href="#0"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/skills4x2.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a>
            <a
              href="#0"
              aria-controls="modal-is-active"
              // onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/received_186075715528673x3.jpeg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a>
            {/* <a href="#0">
              <Image
                className="has-shadow"
                src={require('./../../assets/skils101.jpg')}
                alt="Hero"
                // width={896}
                // height={504}
                width={200}
                height={204}
              />
            </a> */}
          </div>
          {/* 
          {console.log(externamImages[0])} */}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
